import { FetchResponse } from '@cian/http-api';

import { TThunkAction } from '../../types/redux';
import {
  fetchGetStatusAboutCreatedMessageChatMessage,
  TGetStatusAboutCreatedMessageChatMessageResponse,
} from '../../repositories/demand/v1/get-status-about-created-message-chat-message';
import { setChatId } from '../../slices';
import { IGetStatusAboutCreatedMessageChatMessageResponse } from '../../repositories/demand/entities/get_status_about_created_message_chat_message/GetStatusAboutCreatedMessageChatMessageResponse';

export const getStatusAboutChatMessage =
  (): TThunkAction<Promise<IGetStatusAboutCreatedMessageChatMessageResponse | {}>> =>
  async (dispatch, getState, { httpApi, logger }) => {
    const state = getState();
    const { formSubmitData } = state;
    const parameters = { messageId: formSubmitData.messageId as number };

    try {
      const getStatusAboutChatMessage: FetchResponse<TGetStatusAboutCreatedMessageChatMessageResponse> =
        await fetchGetStatusAboutCreatedMessageChatMessage({ httpApi, parameters });

      if (getStatusAboutChatMessage.statusCode === 200) {
        const { chatId, status } = getStatusAboutChatMessage.response;

        dispatch(setChatId({ status, chatId }));

        return getStatusAboutChatMessage.response;
      }

      throw getStatusAboutChatMessage.response;
    } catch (error) {
      logger.error(error, {
        messageId: formSubmitData.messageId,
        errorMessage:
          'Ошибка при получении статуса чата (ручка /public/v1/get-status-about-created-message-chat-message/)',
        domain: 'getStatusAboutChatMessage.test.ts',
      });

      return {};
    }
  };
